<app-banner [loading]="loading" [info]="true" [heading]="heading" [subHeading]="subHeading">


  <div class="toolbar-content">

    @if (displayRevalidationRecords === false) {
      <button class="btn btn-back" (click)="onBackBtnClick()">
        <i class="fa fa-arrow-left"></i>
        <span>Back</span>
      </button>
    }

    @if (displayRevalidationRecords === null) {
      <button class="btn btn-back" (click)="onEntriesBackBtnClick()">
        <i class="fa fa-arrow-left"></i>
        <span>Back</span>
      </button>
    }

    @if (!layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(true)" aria-label="Maximise"
        class="btn btn-back">
        <i class="fa fa-window-maximize"></i>
        <span>maximise</span>
      </button>
    }

    @if (layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(false)" aria-label="Maximise"
        class="btn btn-back">
        <i class="fa fa-window-restore"></i>
        <span>restore</span>
      </button>
    }

  </div>

</app-banner>

<app-collapsible [trigger]="displayRevalidationRecords === true">
  <div class="pad-left-30 no-boxes search-bar">

    <div class="form-inline reg-number">
      <div class="width-100 mrgn-btm-10">
        <input #regNumber (keydown.enter)="search(searchCriteria.regNumber)" placeholder="Registration number..."
          [(ngModel)]="searchCriteria.regNumber" type="text" name="regNumber" class="form-control " />
          <button class="btn btn-primary ml-2" [disabled]="!searchCriteria.regNumber"
          (click)="search(searchCriteria.regNumber)">Search</button>
          <button class="btn btn-default ml-2" [disabled]="!searchCriteria.regNumber"
          (click)="clearSearch()">Clear</button>
        </div>
        @if (registrantName) {
          <h4>Revalidation records belonging to '{{registrantName}}'</h4>
        }
      </div>

    </div>

  </app-collapsible>

  <app-collapsible [trigger]="displayRevalidationRecords === false">
    <div style="display: flex;flex-direction: column;" class="pad-left-30 no-boxes search-bar">

      <div class="form-inline reg-number">
        <h4>Entries by '{{regNo}}' for renewal date: '{{selectedDate | utcDate}}'</h4>
      </div>
    </div>

  </app-collapsible>

  <app-collapsible [trigger]="displayRevalidationRecords">
    @if (revalidations?.length > 0) {
      <div class="content no-boxes fadein mrgn-btm-50" style="padding:0"
        >
        <table class="table" style="font-size: 0.9em;">
          <thead>
            <tr>
              <th style="padding-left: 30px;"> Renewal Date </th>
              <th> Submission deadline </th>
              <th> Revalidation status </th>
              <th> Submission date </th>
              <th> Submission status </th>
              <th> For more details </th>
            </tr>
          </thead>
          <tbody>
            @for (item of revalidations; track item) {
              <tr style="cursor:pointer">
                <td style="padding-left: 30px;"> {{ item.renewalDate | utcDate }}</td>
                <td> {{ item.expectation.submissionDeadline| utcDate }} </td>
                <td> {{ getRevalidationStatus(item.status)}}</td>
                <td> {{ item.submissionDate | utcDate }}</td>
                <td> {{ getSubmissionStatus(item.submissionStatus) }}</td>
                <td>
                  <span class="clickable" (click)="setYearSelected(item.renewalDate)">Click here</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div class="content no-boxes fadein mrgn-btm-50 pad-left-30">
        <div class="no-data">
          No records found
        </div>
      </div>
    }
  </app-collapsible>

  <app-collapsible [trigger]="displayRevalidationRecords === false">
    <div class="content no-boxes fadein" style="padding:0">
      <table class="table more-details" style="font-size: 0.9em;">
        <thead>
          <tr>
            <th style="padding-left: 30px;"> Remediation status </th>
            <th> Remeditaion issued on </th>
            <th> NOIR/NOR status </th>
            <th> NOIR issued on </th>
            <th> NOR issued on </th>
            <th> Review and feedback status </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding-left: 30px;"> {{ getRemediationStatus($safeNavigationMigration(revalidationSelected?.remediationStatus)) || '-'}}
            </td>
            <td> {{ ($safeNavigationMigration(revalidationSelected?.remediationIssuedOn)| utcDate) || '-'}} </td>
            <td> {{ getNoirAndNorStatus($safeNavigationMigration(revalidationSelected?.noirAndNorStatus)) || '-'}} </td>
            <td> {{ ($safeNavigationMigration(revalidationSelected?.noirIssuedOn)| utcDate)|| '-' }} </td>
            <td> {{ ($safeNavigationMigration(revalidationSelected?.norIssuedOn)| utcDate) || '-' }} </td>
            <td> {{ getReviewAndFeedbackStatus($safeNavigationMigration(revalidationSelected?.reviewAndFeedbackStatus)) || '-'}} </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pad-left-30">
      <h5>Expectations :</h5>
    </div>

    <div class="content no-boxes fadein" style="padding:0">
      <table class="table more-details" style="font-size: 0.9em;">
        <thead>
          <tr>
            <th style="padding-left: 30px;"> Total count </th>
            <th> Expected CPDs</th>
            <th> Max unplanned </th>
            <th> Peer discussions </th>
            <th> Reflective accounts </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding-left: 30px;"> {{ expectation?.expectedTotalCount }}</td>
            <td> {{ expectation?.expectedCpds}} </td>
            <td> {{ expectation?.maxUnplanned}} </td>
            <td> {{ expectation?.expectedPeerDiscussions }} </td>
            <td> {{ expectation?.expectedReflectiveAccounts}} </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pad-left-30">
      <h5>Extenuating Circumstances :</h5>
    </div>

    @if (exceptionalCircumstance?.length) {
      <div class="content no-boxes fadein" style="padding:0">
        <table class="table more-details" style="font-size: 0.9em;">
          <thead>
            <tr>
              <th style="padding-left: 30px;"> Completion Status</th>
              <th> Decision</th>
              <th> last Decision Date On </th>
              <th> Subject </th>
              <th> Submitted At </th>
              <th> Type </th>
            </tr>
          </thead>
          <tbody>
            @for (exceptionalCircumstance of exceptionalCircumstance; track exceptionalCircumstance) {
              <tr>
                <td style="padding-left: 30px;"> {{ CompletionStatus[exceptionalCircumstance?.completionStatus] | caseSplit }}
                </td>
                <td> {{ ExtenuatingCircumstanceReviewDecision[exceptionalCircumstance?.decision] | caseSplit}} </td>
                <td> {{ $safeNavigationMigration(exceptionalCircumstance?.lastDecisionDateOn) | utcDate}} </td>
                <td> {{ exceptionalCircumstance?.subject }} </td>
                <td> {{ $safeNavigationMigration(exceptionalCircumstance?.submittedAt) | utcDate}} </td>
                <td> {{ ExtCircType[exceptionalCircumstance?.type] | caseSplit}} </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div class="content no-boxes fadein mrgn-btm-50 pad-left-30">
        <div class="no-data">
          No records found
        </div>
      </div>
    }

    <div class="pad-left-30">
      <h5>Entries details :</h5>
    </div>

    @if (entries?.length > 0) {
      <div class="content no-boxes mrgn-btm-50 fadein" style="padding:0">
        <table class="table more-details" style="font-size: 0.9em;">
          <thead>
            <tr>
              <th style="padding-left: 30px;"> Title </th>
              <th> Type </th>
              <th> Is completed? </th>
              <th> Is submitted? </th>
              <th> Last Updated On </th>
            </tr>
          </thead>
          <tbody>
            @for (item of entries; track item) {
              <tr>
                <td style="padding-left: 30px;" class="clickable" (click)="fetchEntryDetailsByTitle(item)"> {{ item.title }}
                </td>
                <td> {{ getRevalidationItemType(item.type) }} </td>
                <td> {{ (item.isCompleted)}}</td>
                <td> {{ item.isSubmitted }}</td>
                <td> {{ item.lastUpdatedOn | utcDate }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div class="content no-boxes fadein mrgn-btm-50 pad-left-30">
        <div class="no-data">
          No records found
        </div>
      </div>
    }
  </app-collapsible>


  <app-collapsible [trigger]="displayRevalidationRecords === null">
    <section>
      <div class="row content spread" style="padding-bottom:0">
        <div class="col-md-9 fadein">
          <div class="cpd-entry">
            @if (entryDetails && entryDetails['title']) {
              <div class="header-container pb-3">
                <h4> <span [innerHTML]="entryDetails.title"></span></h4>
              </div>
            }
            @if (entryDetails && entryDetails.questionGroups.length) {
              <div>
                @for (group of entryDetails.questionGroups; track group; let i = $index) {
                  <div>
                    @if (group.questions && group.questions.length) {
                      <div>
                        @for (question of group.questions; track question; let i = $index) {
                          <div>
                            <div class="question">
                              <b [innerHTML]="question.title"></b>
                            </div>
                            @if (question.type === AnswerType.DateTime) {
                              <div class="answer pb-2">
                                {{ question.answer | date:'dd/MM/yyyy HH:mm'}}
                              </div>
                            }
                            @if (question.type !== AnswerType.DateTime) {
                              <div class="answer pb-2" [innerHTML]="question.answer">
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }

          </div>
        </div>

      </div>
    </section>
  </app-collapsible>

